import { Mic, Send } from '@mui/icons-material';
import { Dialog, DialogContent } from '@mui/material';
import React,{useEffect, useState,useRef} from 'react'

function DeviceChatBox({device,publishMessage,newChat,setNewChat}) {
    const [msg,setMsg] = useState("");
    const [msgLog,setMsgLog] = useState([]);
    const [dialogStatus, setDialogStatus] = useState(false);
    const messagesEndRef = useRef(null);

    let msgPrefix = "";
    



    
    const submitMessage = () => {
        publishMessage(device.topicBase+"command",msg)
        setNewChat({deviceName : "You",msg:msg})
        setMsg("");
    }

    const sendMessage = (_msg) => {

        let messageToPublish = msgPrefix+_msg;
        console.log("message prefix is",msgPrefix)
        console.log("messageto publish",messageToPublish)
        publishMessage(device.topicBase+"command",messageToPublish)
        setNewChat({deviceName : "You",msg:_msg})
        setMsg("");
        msgPrefix = ""
    }

    const listen = () =>{
        let SR = window.SpeechRecognition || window.webkitSpeechRecognition;
        let r = new SR();
        //console.log(r);
        r.start();
        r.onstart = (e) =>{
            //setMsg("");
            setDialogStatus(true);
            //console.log("Started")
        }
        r.onend = (e) =>{
            setDialogStatus(false);
            //console.log("ended")
        }
        r.onresult = (e) =>{
            console.log(e);
            console.log(e.results[0][0].transcript)
            setMsg(e.results[0][0].transcript)
            sendMessage(e.results[0][0].transcript)
            //setListenValue(e.results[0][0].transcript);
        }
    }

    
    const handelNewChat = () =>{
        if(newChat!==null){
            setMsgLog(msgLog=>[...msgLog,newChat])
            if(newChat.messageObj !== undefined ){
                speak(newChat.messageObj?.reply);
            }
            if(newChat.messageObj?.link !== undefined && newChat.messageObj?.link !== ""){
                console.log("we received a link", newChat.messageObj?.link);
                window.open(newChat.messageObj?.link, '_blank', 'noopener,noreferrer')
            }
            if(newChat.messageObj?.type == "query"){
                setTimeout(()=>{
                    listen()
                },3000)
            }
            if(newChat.messageObj?.type == "followup"){
                console.log("message prefix is ",newChat.messageObj?.response)
                //setMsgPrefix(newChat.messageObj?.response)
                msgPrefix = newChat.messageObj?.response
                setTimeout(()=>{
                    listen()
                },3000)
            }
        }
    }

    useEffect(()=>{
        handelNewChat()
    },[newChat])



    const speak = (text) =>{
        let voiceIndex = sessionStorage.getItem('voiceIndex');
        var uttr = new SpeechSynthesisUtterance();
        uttr.text = text;
        //console.log(speechSynthesis.getVoices())
        uttr.voice = speechSynthesis.getVoices()[voiceIndex];
        speechSynthesis.speak(uttr)
        //messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }


    return (
        <div>
            {/*JSON.stringify(msgLog)*/}
            <div className="border border-primary p-2 rounded" style={{overflowY:"auto",height:300, maxHeight:300}} >
                {msgLog.map((log,i)=>
                    <p key={i} > <span className="fw-bold">{log.deviceName}</span> : {log.msg}</p>
                )}
                <div ref={messagesEndRef}></div>
            </div>
            {msgPrefix}
            <div className="input-group">
                <input type="text" className="form-control" value={msg} onChange={(e)=>setMsg(e.target.value)} />
                <button type="button" className="btn btn-outline-default" onClick={listen} ><Mic /></button>
                <button type="button" className="btn btn-primary" onClick={submitMessage} ><Send/></button>
            </div>

            <Dialog
                open={dialogStatus}
                maxWidth="md"
            >
                <DialogContent>
                    <h4>Listning...</h4>
                    <div className='gtoken-mic'></div>
                </DialogContent>

            </Dialog>
        </div>
    )
}

export default DeviceChatBox